import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faMoneyBill1,
  faCalendarAlt,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

const Postedvacancies = ({ userId }) => {
  const { t } = useTranslation();
  const [vacancies, setVacancies] = useState([]);
  const [companyInfo, setCompanyInfo] = useState(null); // Сохраняем данные компании отдельно
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    const fetchVacancies = async () => {
      try {
        const res = await fetch(`/api/company_vacancies.php?id=${userId}`);
        const data = await res.json();
        if (data.success) {
          setVacancies(data.vacancies || []);
          setCompanyInfo(data.company || null); // Запоминаем инфо о компании
        }
      } catch (err) {
        console.error("Error fetching vacancies:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchVacancies();
  }, [userId]);

  const visibleVacancies = vacancies.slice(0, 3);
  const placeholders = Math.max(0, 3 - visibleVacancies.length);

  // Дефолтный логотип, если у компании его нет
  const logoSrc = companyInfo?.companyLogo 
    ? `/api/uploads/${companyInfo.companyLogo}` 
    : "/api/default-avatar.png";

  return (
    <section className="w-full flex justify-start items-end px-[20px] flex-col gap-5">
      <h1 className="w-full max-md:text-xl text-white font-bold uppercase text-start text-4xl">
        {t("lastvacansies")}
      </h1>

      {loading ? (
        <p className="text-white text-lg animate-pulse">{t("Loading")}...</p>
      ) : (
        <section className="w-full flex justify-start mb-12 flex-wrap items-center gap-5">
          {/* Вакансии */}
          {visibleVacancies.map((vac) => (
            <div
              key={vac.id}
              className="w-[490px]  bg-white border-[3px] border-[#006674] text-[#006674] 
                         max-2xl:w-[350px] max-lg:w-[300px] max-md:w-full overflow-hidden flex-col relative 
                         flex justify-between rounded-lg shadow-lg"
            >
              <div className="w-full px-3 pt-3 flex justify-start items-center gap-[13px] sm:gap-6 ">
                <img
                  className="w-[100px] h-[100px] object-contain rounded-xl border-[4px] border-white bg-gray-100 shadow-md"
                  src={logoSrc}
                  alt={companyInfo?.companyName || "Company"}
                />
                <ul className="flex flex-col gap-1 items-start justify-center">
                  <Link to={`/vacancy/${vac.id}`} className="text-xl font-semibold text-[#006674] hover:underline">
                    {vac.workname}
                  </Link>
                  <li className="text-gray-600 max-sm:text-md">{companyInfo?.companyName}</li>
                  <li className="flex gap-2 items-center text-gray-700">
                    <FontAwesomeIcon icon={faLocationDot} />
                    {vac.workplace}
                  </li>
                  <li className="flex gap-2 items-center text-gray-700">
                    <FontAwesomeIcon icon={faMoneyBill1} />
                    {vac.salaryType === "contract" ? (
                      <span>{t("Contract")}</span>
                    ) : vac.salaryType === "undefined" ? (
                      <span>{t("Undefined Salary")}</span>
                    ) : vac.salary ? (
                      <span>
                        {vac.salary}{" "}
                        {vac.currency === "AMD" && <span>֏</span>}
                        {vac.currency === "USD" && <span>$</span>}
                        {vac.currency === "RUB" && <span>₽</span>}
                        {vac.currency === "EUR" && <span>€</span>}
                      </span>
                    ) : (
                      <span>{t("Indefinite")}</span>
                    )}
                  </li>
                </ul>
              </div>

              {/* Нижняя плашка вакансии */}
              <div className="w-full p-2 bg-[#006674] text-white flex justify-between items-center">
                <span>
                  <FontAwesomeIcon className="mr-1" icon={faCalendarAlt} />
                  {vac.created_at ? new Date(vac.created_at).toLocaleDateString() : "---"}
                </span>
                <Link to={`/vacancy/${vac.id}`} className="hover:underline">
                  {t("seemore")}
                </Link>
              </div>
            </div>
          ))}

          {/* Плейсхолдеры-плюсики */}
          {[...Array(placeholders)].map((_, idx) => (
            <Link
              key={`plus-${idx}`}
              to="/AddVacancy"
              className="w-[490px] h-[180px] bg-[#00667480] border-[3px] border-dashed border-white 
                         max-2xl:w-[350px] max-lg:w-[300px] max-md:w-full flex justify-center items-center 
                         rounded-lg shadow-2xl text-white text-3xl hover:bg-[#006674a3] transition"
            >
              <FontAwesomeIcon icon={faPlus} />
            </Link>
          ))}
        </section>
      )}

      {/* Кнопка для открытия всех вакансий */}
      {vacancies.length > 2 && (
        <div className="w-full flex justify-end items-center mt-4">
          <Link
            to={`/ViewConmpanyVacancies/${userId}`}
            className="mr-6 text-white text-lg font-semibold relative before:top-full before:w-0 before:transition-all
                       before:duration-200 before:h-[2px] before:absolute before:bg-white hover:before:w-full"
          >
            {t("seemore")}
          </Link>
        </div>
      )}
    </section>
  );
};

export default Postedvacancies;